import { type GetHookResponse } from '../hooks'
import { rubricKey } from '../keys'
import { useTantalimQuery } from '../query'
import {
  type RubricId,
  type RubricData,
  type RecordingRubricGetInput,
  type RecordingRubricGetSuccess,
} from '@terros/common'

export function useRubric(rubricId: RubricId | undefined): GetHookResponse<RubricData> {
  return useTantalimQuery<RecordingRubricGetInput, RecordingRubricGetSuccess, RubricData>({
    url: '/recording/rubric/get',
    queryKey: rubricKey(rubricId),
    input: { rubricId: rubricId ?? 'Rubric.NO_RUBRIC_DEFINED' },
    convertResponse: (data) => data.rubric,
    options: {
      enabled: rubricId !== undefined,
    },
  })
}
